import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import jsPDF from 'jspdf';

@Component({
  selector: 'app-qr-codedialog',
  templateUrl: './qr-codedialog.component.html',
  styleUrls: ['./qr-codedialog.component.css']
})
export class QrCodedialogComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<QrCodedialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
  }

  close = () => {
    this.dialogRef.close(true);
  }



  downloadQRCode(file) {
    const doc = new jsPDF('p', 'pt', 'a4', true);
    const text =
      'Facility Name:' + this.data?.facilityName + '\n' +
      'Name:' + this.data?.name + '\n' +
      'Gin:' + this.data?.gin;
    doc.text(text, 50, 50);
    doc.addImage(file, 'PNG', 120, 120, 350, 300, '', 'FAST');
    doc.save('RQ ID-' + this.data.id + '.pdf');
  }

}
